import { ModalInfoTemplateProps } from '.';
import { ModalErrorTitle } from 'modules/modals/components/ModalErrorMessage';

const template: ModalInfoTemplateProps = {
  ariaLabel: 'Remove Points Error',
  closeLabel: 'Close',
  renderHeader: () => <ModalErrorTitle />,
};

export default template;
